module.exports = __webpack_public_path__ + "img/optimist.0db4959a.svg";